import { render, staticRenderFns } from "./cabinet-qualification-success.vue?vue&type=template&id=982eff2e&scoped=true"
import script from "./cabinet-qualification-success.vue?vue&type=script&lang=js"
export * from "./cabinet-qualification-success.vue?vue&type=script&lang=js"
import style0 from "./cabinet-qualification-success.vue?vue&type=style&index=0&id=982eff2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982eff2e",
  null
  
)

export default component.exports